export const host = process.env.REACT_APP_API_URL
export const registerRoute = `${host}/api/auth/register`
export const loginRoute = `${host}/api/auth/login`
export const setAvatarRoute = `${host}/api/auth/setavatar`
export const usersRoute = `${host}/api/auth/users`
export const userRoute = `${host}/api/auth/user`
export const messageRoute = `${host}/api/message/addmsg`
export const getMessageRoute = `${host}/api/message/getmsg`